import { useCallback } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CompliancePage } from '@/features/compliance/compliance-page'
import { COMPLIANCE_TABS, type ComplianceTab } from '@/features/compliance/constants'
import { requirePermission } from '@/lib/route-guards'

/** `?tab=` recuerda la pestaña (alertas, RTE, PEP). */
const complianceSearchSchema = z.object({
  tab: z.enum(COMPLIANCE_TABS).optional().catch(undefined),
})

/** Cumplimiento: alertas, registro de efectivo y clientes PEP. */
export const Route = createFileRoute('/_app/compliance/')({
  beforeLoad: requirePermission('compliance:read'),
  validateSearch: complianceSearchSchema,
  component: ComplianceRoute,
})

function ComplianceRoute() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const onTabChange = useCallback((next: ComplianceTab) => void navigate({ search: { tab: next }, replace: true }), [navigate])
  return <CompliancePage tab={tab ?? 'alerts'} onTabChange={onTabChange} />
}
